import React from "react";
import CustomTag from "../util/CustomTag";
import MotionDivLeftToRight from "../SectionComponents/MotionDivLeftToRight";

export default function Button({
  icon,
  label,
  onClick,
  buttonLink,
  className,
  textclassName,
  size,
  sizeFeatures,
  gap,
  removeTarget,
  removeAnchor,
  tagName,
  color = "bg-primary",
  animation = true,
}) {
  if (size === "small") {
    sizeFeatures = "rounded-[4px] px-[18px] py-[10px]";
    textclassName = textclassName || "text-paragraph3 font-secondFont";
    gap = "gap-[10px]";
  } else {
    sizeFeatures = "rounded-[8px] px-[30px] py-[16px]";
    textclassName = textclassName || "text-paragraph4 font-secondFont";
    gap = "gap-[20px]";
  }

  const Animation = animation ? MotionDivLeftToRight : "div";

  const CustomTagName = removeAnchor ? "div" : tagName || "a";

  return (
    <CustomTag
      tagName={CustomTagName}
      {...(removeTarget ? {} : { target: "_blank" })}
      {...(removeAnchor ? {} : { href: buttonLink })}
      className=""
    >
      <Animation className="w-fit">
        <button
          onClick={onClick}
          className={`flex ${className} ${sizeFeatures} flex-row items-center justify-around transition ${color} text-darker hover:scale-110 w-fit`}
        >
          <div className={`flex items-center text-center ${gap} min-h-[24px]`}>
            <div className="">{icon}</div>
            <p className={`flex items-center ${textclassName}`}>{label}</p>
          </div>
        </button>
      </Animation>
    </CustomTag>
  );
}
